import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useBrand } from "@/contexts/BrandContext";
import posthog from "@/lib/posthog";
import { isEmbeddedSurface } from "@/lib/embedded-surface";

export function PostHogTracker() {
  const { pathname } = useLocation();
  const { user, activeWorkspaceId, subscriptionStatus, organizationName } = useAuth();
  const brand = useBrand();
  const prevUserRef = useRef<string | null>(null);

  // Page views
  useEffect(() => {
    if (isEmbeddedSurface()) return;
    posthog.capture("$pageview");
  }, [pathname]);

  // Identify & group on auth change
  useEffect(() => {
    if (user) {
      posthog.identify(user.id, {
        email: user.email,
        name: user.user_metadata?.full_name,
        brand: brand.id,
        subscription_status: subscriptionStatus,
      });

      if (activeWorkspaceId) {
        posthog.group("organization", activeWorkspaceId, {
          name: organizationName,
          subscription_status: subscriptionStatus,
        });
      }

      prevUserRef.current = user.id;
    } else if (prevUserRef.current) {
      posthog.reset();
      prevUserRef.current = null;
    }
  }, [user, activeWorkspaceId, subscriptionStatus, organizationName, brand.id]);

  // Brand as super property
  useEffect(() => {
    posthog.register({ brand: brand.id });
  }, [brand.id]);

  return null;
}
